import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable, theme-aware skeleton loader for the Cargo Heating module.
 *
 * ONE consistent design (same shimmer + tokens) reused everywhere.
 * Light/Dark is picked up automatically via `:host-context(.ch-light)`,
 * so it matches whichever Cargo Heating theme is active.
 *
 * Usage:
 *   <app-ch-skeleton variant="tiles" [tiles]="4"></app-ch-skeleton>
 *   <app-ch-skeleton variant="table" [rows]="8" [cols]="8"></app-ch-skeleton>
 *   <app-ch-skeleton variant="chart"></app-ch-skeleton>
 *   <app-ch-skeleton variant="cards" [rows]="5"></app-ch-skeleton>
 *   <app-ch-skeleton variant="form" [rows]="6"></app-ch-skeleton>
 *   <app-ch-skeleton variant="lines" [rows]="4"></app-ch-skeleton>
 */
@Component({
  selector: 'app-ch-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ch-skeleton.component.html',
  styleUrls: ['./ch-skeleton.component.scss'],
})
export class ChSkeletonComponent {
  @Input() variant: 'table' | 'tiles' | 'chart' | 'cards' | 'lines' | 'form' = 'lines';
  @Input() rows = 6;
  @Input() cols = 6;
  @Input() tiles = 4;

  get rowArray(): number[] {
    return Array.from({ length: Math.max(0, this.rows) }, (_, i) => i);
  }

  get colArray(): number[] {
    return Array.from({ length: Math.max(0, this.cols) }, (_, i) => i);
  }

  get tileArray(): number[] {
    return Array.from({ length: Math.max(0, this.tiles) }, (_, i) => i);
  }

  get legendArray(): number[] {
    return [0, 1, 2, 3];
  }
}
